const getInitialState = () => ({
  id: null,
  firstName: '',
  lastName: '',
  username: '',
  classroomId: null,
  grade: '',
  bestResults: {
    wpm: {},
    accuracy: {}
  },
  homeUseToken: '',
  spotCheckRetries: 0,
  token: '',
  licenses: [],
  curriculum: [],
  position: {
    next: {},
    last: {}
  },
  successfullyLoggedIn: false,
  stopAndReviewWeek: 0,
  sessionId: '',
  accessibilitySettings: {
    audioSettings: {
      volume: 100,
      muteSounds: false
    },
    closedCaptionsSettings: {
      showClosedCaptions: false,
      closedCaptionSize: 22
    },
    videoNarrationSettings: {
      showSettings: false
    }
  },
  oneHandedTypingHand: ''
});

export default getInitialState;
